import React, { Component } from 'react';
import {Link} from 'react-router-dom';

import './../App.css';

import HamburguerMenu from '../assets/hamburguer-menu.png';


class MobileHeader extends Component {
  constructor(){
    super();

    this.state= {
      visible: "displayNone"
    }
  }

  handleToggleMenu(){
    if(this.state.visible === "displayNone"){
      this.setState({ visible : ""});
    }else{
      this.setState({ visible : "displayNone"});
    }
  }

  render() {
    return (
        <div id="MobileHeader">
            <a href="javascript:void(0)" onClick={this.handleToggleMenu.bind(this)} ><img src={HamburguerMenu} /></a>
            <nav id="MobileHeader-floatMenu" className={this.state.visible}>
              <ul>
                <li><Link to="/" onClick={this.handleToggleMenu.bind(this)}>Home</Link></li>
                <li><Link to="/empresa" onClick={this.handleToggleMenu.bind(this)}>Empresa</Link></li>
                <li><Link to="/localizacao" onClick={this.handleToggleMenu.bind(this)}>Localização</Link></li>
                <li><Link to="/produtos" onClick={this.handleToggleMenu.bind(this)}>Produtos</Link></li>
                <li><Link to="/ilpf" onClick={this.handleToggleMenu.bind(this)}>O que é ilpf</Link></li>
                <li><Link to="/contato" onClick={this.handleToggleMenu.bind(this)}>contato</Link></li>
              </ul>

              <div id="MobileHeader-fecharMenu" onClick={this.handleToggleMenu.bind(this)} >
                X
              </div>
            </nav>
        </div>
    );
  }
}

export default MobileHeader;



// WEBPACK FOOTER //
// ./src/Header/MobileHeader.js